// Simple in-browser wishlist using localStorage
// Adds a heart button to product cards and product pages,
// and a "My Wishlist" page render via /pages/wishlist section (see wishlist-page.liquid)

(function () {
  const STORAGE_KEY = 'misdirection_wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:updated', { detail: { count: list.length } }));
  }

  function isInWishlist(handle) {
    return getWishlist().some((item) => item.handle === handle);
  }

  function toggleWishlist(product) {
    let list = getWishlist();
    const exists = list.some((item) => item.handle === product.handle);
    if (exists) {
      list = list.filter((item) => item.handle !== product.handle);
    } else {
      list.push(product);
    }
    saveWishlist(list);
    return !exists;
  }

  function updateButtonState(button) {
    const handle = button.dataset.wishlistHandle;
    const active = isInWishlist(handle);
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.textContent = active ? '♥' : '♡';
  }

  function initButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      updateButtonState(button);
      button.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        const product = {
          handle: button.dataset.wishlistHandle,
          title: button.dataset.wishlistTitle,
          image: button.dataset.wishlistImage,
          price: button.dataset.wishlistPrice,
          url: button.dataset.wishlistUrl
        };
        toggleWishlist(product);
        updateButtonState(button);
      });
    });
  }

  document.addEventListener('DOMContentLoaded', initButtons);
  document.addEventListener('wishlist:updated', () => {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(updateButtonState);
    const counters = document.querySelectorAll('[data-wishlist-count]');
    const count = getWishlist().length;
    counters.forEach((el) => { el.textContent = count; });
  });

  // Init counters on load
  document.addEventListener('DOMContentLoaded', () => {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach((el) => { el.textContent = count; });
  });

  window.MisdirectionWishlist = { getWishlist, toggleWishlist, isInWishlist };
})();
